import { mapEnumToOptions } from '@abp/ng.core';

export enum ProjectEDDAStatus {
  SavedAsDraft = 0,
  InProgress = 1,
  Sent = 2,
}

export const projectEDDAStatusOptions = mapEnumToOptions(ProjectEDDAStatus);
